import React from "react";
import { Sun, Moon, Desktop } from "@phosphor-icons/react";
import { useTheme } from "@/lib/theme";

const OPTIONS = [
  { v: "light", label: "Açık", Icon: Sun },
  { v: "dark", label: "Koyu", Icon: Moon },
  { v: "system", label: "Sistem", Icon: Desktop },
];

/**
 * Compact 3-way segmented theme switcher (Açık / Koyu / Sistem).
 * `compact=true` renders an icon-only version suitable for sidebars.
 */
export default function ThemeToggle({ compact = false, className = "" }) {
  const { theme, setTheme } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Tema seçimi"
      data-testid="theme-toggle"
      className={`inline-flex items-center gap-0.5 p-0.5 rounded-full border border-border bg-card ${className}`}
    >
      {OPTIONS.map(({ v, label, Icon }) => {
        const active = theme === v;
        return (
          <button
            key={v}
            role="radio"
            aria-checked={active}
            onClick={() => setTheme(v)}
            data-testid={`theme-${v}`}
            title={label}
            className={`flex items-center gap-1.5 ${compact ? "px-2" : "px-2.5"} py-1.5 rounded-full text-xs font-medium transition-colors ${
              active
                ? "bg-[#3A5A40] text-white"
                : "text-foreground/70 hover:text-foreground hover:bg-muted"
            }`}
          >
            <Icon size={13} weight={active ? "fill" : "duotone"} />
            {!compact && <span>{label}</span>}
          </button>
        );
      })}
    </div>
  );
}
